
import { IonPage, IonContent, IonText, IonSlides, IonSlide } from '@ionic/vue'
import { defineComponent } from 'vue'
import MyHeader from '@/components/layouts/MyHeader.vue'
import { useFirebaseAuthModule } from '@/provider/FirebaseAuthModule'
import FirestoreAuthModal from '@/components/organisms/settings/FirestoreAuthModal.vue'

export default defineComponent({
  components: {
    IonContent,
    IonPage,
    IonText,
    IonSlides,
    IonSlide,
    MyHeader,
    FirestoreAuthModal,
  },
  setup() {
    const { user } = useFirebaseAuthModule()
    return {
      user,
    }
  },
})
